import BaseApiService from "./BaseApiService";

class SectionApiService extends BaseApiService {
  getSections = async (courseId) => {
    const response = await this.getAxiosInstance().get(`/internal/courses/${courseId}/sections`);
    return response.data.data.sections.map((section) => ({
      id: section._id,
      title: section.name,
      displayOrder: section.displayOrder,
      lessons: (section.lessons || []).map((lesson) => ({
        id: lesson._id,
        title: lesson.name,
        duration: lesson.duration || "1 minutes",
        completed: false,
        video: lesson.content,
        overview: lesson.description,
        displayOrder: lesson.displayOrder,
        type: lesson.type,
      })),
    }));
  };

  createSection = async (courseId, name) => {
    const response = await this.getAxiosInstance().post(`/internal/courses/${courseId}/sections`, { name });
    return response.data;
  };

  deleteSection = async (sectionId) => {
    const response = await this.getAxiosInstance().delete(`/internal/sections/${sectionId}`);
    return response.data;
  };

  updateSection = async (sectionId, name) => {
    const response = await this.getAxiosInstance().put(`/internal/sections/${sectionId}`, { name });
    return response.data;
  };

  reorderSection = async (courseId, sectionId, frontSectionId, behindSectionId) => {
    const body = {};
    if (frontSectionId) body.frontSectionId = frontSectionId;
    if (behindSectionId) body.behindSectionId = behindSectionId;
    const response = await this.getAxiosInstance().put(
      `/internal/courses/${courseId}/sections/${sectionId}/reorder`,
      body
    );
    return response.data;
  };

  reorderLesson = async (courseId, sectionId, lessonId, frontLessonId, behindLessonId) => {
    const body = {};
    if (frontLessonId) body.frontLessonId = frontLessonId;
    if (behindLessonId) body.behindLessonId = behindLessonId;
    const response = await this.getAxiosInstance().put(`/internal/lessons/${lessonId}/reorder`, body);
    return response.data;
  };

  createLesson = async (sectionId, payload, type = "html") => {
    if (type === "video") {
      const response = await this.getAxiosInstance().post(`/internal/sections/${sectionId}/lessons`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout:60000 ,
      });
      return response.data;
    } else {
      const cleanPayload = { ...payload, type: "HTML" };
      const response = await this.getAxiosInstance().post(`/internal/sections/${sectionId}/lessons`, cleanPayload, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    }
  };
  // Trong SectionApiService.js

  updateLesson = async (lessonId, payload, type = "html") => {
    // type: "html" hoặc "video"
    if (type.toLowerCase() === "video") {
      // payload là FormData
      const response = await this.getAxiosInstance().put(`/internal/lessons/${lessonId}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } else {
      // HTML: gửi JSON
      const cleanPayload = { ...payload, type: "HTML" };
      const response = await this.getAxiosInstance().put(`/internal/lessons/${lessonId}`, cleanPayload, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    }
  };

  getLessonDetail = async (lessonId) => {
    const res = await this.getAxiosInstance().get(`/internal/lessons/${lessonId}`);
    const lesson = res.data.data.lesson;
    // Normalize type to "Video" or "HTML"
    const type =
      typeof lesson.type === "string" ? (lesson.type.trim().toUpperCase() === "HTML" ? "HTML" : "Video") : "Video";
    return {
      id: lesson._id,
      sectionId: lesson.sectionId,
      title: lesson.name,
      description: lesson.description,
      type, // use normalized type here!
      htmlContent: lesson.htmlContent,
      isPreview: lesson.isPreview,
      video:
        type === "Video" && lesson.videoUrl?.bucket && lesson.videoUrl?.s3Key
          ? `https://${lesson.videoUrl.bucket}.s3.amazonaws.com/${lesson.videoUrl.s3Key}`
          : undefined,
      duration: lesson.duration || "1 minutes",
      overview: lesson.description,
      displayOrder: lesson.displayOrder,
      createdAt: lesson.createdAt,
      updatedAt: lesson.updatedAt,
    };
  };

  deleteLesson = async (lessonId) => {
    const response = await this.getAxiosInstance().delete(`/internal/lessons/${lessonId}`);
    return response.data;
  };

  getLessonVideoUrl = async (lessonId) => {
    const response = await this.getAxiosInstance().get(`/internal/lessons/${lessonId}/video-stream-url`);
    return response.data;
  };
}

export default new SectionApiService();
